import { BASE_URL } from "./index";

// Auth URL's
export const AUTH_URL = "auth";

// Client Dashboard
export const CLIENT_DASHBOARD = "/client-dashboard";
export const CLIENT_DASHBOARD_DELIVERED_COUNT =
  CLIENT_DASHBOARD + "/count/delivered";
export const CLIENT_DASHBOARD_UN_DELIVERED_COUNT =
  CLIENT_DASHBOARD + "/count/undelivered";
export const CLIENT_DASHBOARD_OFD_COUNT = CLIENT_DASHBOARD + "/count/odf";
export const CLIENT_DASHBOARD_RTS_COUNT = CLIENT_DASHBOARD + "/count/rts";

// Client Shipments
export const CLIENT_ORDERS = "/orders";
export const CLIENT_ORDERS_SEARCH = CLIENT_ORDERS + "/search";

// Client Product Inventory
export const INVENTORIES = "/inventories";

// New WMS
export const WMS = "/wms";
export const WMS_PRODUCTS = WMS + "/products";
export const WMS_INBOUNDS = WMS + "/inbounds";

// Orders
export const ORDERS_URL = "orders";
export const FILTER_ORDERS_URL = ORDERS_URL + "/filter";
export const ORDER_STATUS = ORDERS_URL + "/status";
export const COD_ORDERS = ORDERS_URL + "/cod-orders";
export const COD_ORDERS_OLD = ORDERS_URL + "/cod-orders-old";
export const ORDER_STATUSES = "order-statuses";

// Order Comments
export const COMMUNICATION_HISTORY = "order-comments";

// Admin Dashboard
export const ADMIN_DASHBOARD = "admin-dashboard";
export const ADMIN_DASHBOARD_COUNT = ADMIN_DASHBOARD + "/count";
export const ADMIN_DASHBOARD_TOP_STATUS = ADMIN_DASHBOARD + "/top-status";
export const ADMIN_DASHBOARD_ORDERS_BY_REGION =
  ADMIN_DASHBOARD + "/orders-region";
export const ADMIN_DASHBOARD_COD_STATUS_VALUE =
  ADMIN_DASHBOARD + "/cod-status-value";
export const ADMIN_DASHBOARD_STATUS_BY_3PL = ADMIN_DASHBOARD + "/tpl-status";
export const ADMIN_DASHBOARD_VOLUME_BY_MONTH =
  ADMIN_DASHBOARD + "/volume-month";
export const ADMIN_DASHBOARD_DELIVERED_AGING =
  ADMIN_DASHBOARD + "/delivered-aging";
export const ADMIN_DASHBOARD_PENDING_AGING = ADMIN_DASHBOARD + "/pending-aging";
export const ADMIN_DASHBOARD_3PL_MANIFEST_REPORT =
  ADMIN_DASHBOARD + "/tpl-handover";
export const ADMIN_DASHBOARD_CLIENT_WISE_DAILY_PICKUP_REPORT =
  ADMIN_DASHBOARD + "/daily-pickup/client-wise";

// Reports
export const REPORTS = "reports";
export const ADMIN_DASHBOARD_MANIFEST_REPORT = REPORTS + "/manifest-handover";
export const ADMIN_DASHBOARD_EXPORT_MANIFEST_REPORT =
  REPORTS + "/export-manifest-handover";
export const TPL_INVOICE_URL = "/tpl-invoices";

// Admin Setup
export const COUNTRIES_URL = "countries";
export const REGIONS_URL = "regions";
export const HUBS_URL = "hubs";
export const CITIES_URL = "cities";
export const THREEPL_URL = "tpl-companies";
export const TPL_BULK_UPDATE_URL = ORDERS_URL + "/change-tpl/bulk";
export const DISTRICT_URL = "districts";
export const DEPARTMENTS_URL = "departments";
export const DEPARTMENTS_WISE_ROLES = DEPARTMENTS_URL + "/roles";
export const EMPLOYEES_URL = "employees";
export const CLIENTS = "clients";
export const CLIENT_SIGNUP = "clients/signup";
export const SERVICE_TYPES = "service-types";
export const CLIENT_PRODUCTS = "clients/clientId/products";
export const CLIENT_SERVICE_TYPES = "clients/clientId/services";
export const CLIENT_WMS_AUTH_KEY = "clients/wms/auth-key";
export const UNMAPPED_CITY = "tpl-company/unmapped";
export const CLIENT_ADDRESS = "client-address";
export const AWB_BULK_UPLOAD = "pickup/upload-awb/bulk";
export const CLIENT_PICKUP_REQUEST = "client-pickup-request";
export const CLIENT_RESET_PASSWORD = "clients/clientId/reset-password";
export const EMPLOYEE_RESET_PASSWORD = "employees/empId/reset-password";
export const TPL_CITIES_URL = "tpl-cities";
export const PRINT_TPL_LOGS_URL = "/logs/print-3pl";
export const PRINT_LABEL_LOGS_URL = "/logs/print-label";
export const PRINT_INVOICE_LOGS_URL = "/logs/print-invoice";
export const EXCEL_EXPORT_LOGS_URL = "/logs/excel-export";
export const TPL_STATUS_LOGS_URL = "/logs/3pl-status";
export const CLIENT_LOGS_URL = "/logs/client";
export const NOTIFICATION_LOGS_URL = "/logs/notification";
export const INBOUND_STATUS_LOGS_URL = "/logs/inbound-status";
export const AMAZON_RATES_URL = "/admin/amazon/rates";
export const AMAZON_CHARGES_URL = "/admin/amazon/charges";
export const AMAZON_WEIGHT_CHARGES_URL = "/admin/amazon/weight-charges";
export const AMAZON_GENERATE_REPORT_URL = "/admin/amazon/report";
export const AMAZON_WEEKLY_REPORT_LOGS_URL = "/logs/amazon/weekly-report";

// User Permission
export const EMPLOYEE_PERMISSIONS = "/users/employee/permissions";

// Admin operations
export const ADMIN_ORDER_URL = "admin/orders";
export const ADMIN_CLIENT_ORDERS_URL = "admin/clients/orders";
export const ADMIN_CLIENT_ORDERS_PRINT_LABEL_URL =
  "admin/clients/orders/print-label";
export const ADMIN_CLIENT_ORDERS_PRINT_AIDUK_LABEL_URL =
  "admin/clients/orders/print-aiduk-label";
export const ADMIN_CLIENT_ORDERS_PRINT_ESNAD_LABEL_URL =
  "admin/clients/orders/print-esnad-label";
export const ADMIN_CLIENT_ORDERS_PRINT_INVOICE_URL =
  "admin/orders/print-invoice";
export const ADMIN_CLIENT_ORDERS_PRINT_AMAZON_LABEL_URL =
  "admin/orders/print-amazon-label";
export const ADMIN_CLIENT_ORDERS_PRINT_3PL_LABEL_URL =
  "admin/clients/orders/print-3pl-label";
export const ADMIN_ORDERS_GENERATE_3PL_LABEL_BULK_URL =
  "admin/orders/generate/tpl-label";
export const ADMIN_CLIENT_ORDERS_EXPORT_URL =
  "admin/clients/orders/excel-export";
export const ADMIN_CLIENT_ORDERS_WMS_PUSH_URL = "admin/orders/push-to-wms";
export const ADMIN_3PL_CHARGES_EXPORT_URL =
  "admin/tpl-charges/excel-export";
export const ADMIN_SCAN_SUMMARY_ORDERS_URL = "admin/scan-summary/excel-export";
export const ADMIN_SCAN_UNDELIVERY_URL = "admin/scan-undelivery";
export const DOWNLOAD_FILE_URL = `${BASE_URL}/download-file`;
export const ADMIN_UPDATE_POD_ORDERS_URL = "admin/update-pod/orders";

export const ADMIN_COD_STATUS = "admin/cod-status";

export const ADMIN_MARK_ORDER_DELETE = "admin/orders/delete/bulk";
export const ADMIN_UPDATE_ORDER_STATUS = "admin/orders/status/bulk";
export const ADMIN_GET_ORDER_STATUS = "admin/orders/status/bulk";

// 3PL not remitted orders
export const ADMIN_3PL_NOT_REMITTED_ORDERS =
  "admin/clients/orders/3pl-not-remitted";

// RTS Requests
export const RTS_REQUEST_URL = "rts-requests";
export const RTS_FILE_UPLOAD = RTS_REQUEST_URL + "/upload";

// DTS Requests
export const DTS_REQUEST_URL = "dts-request";
export const DTS_FILE_UPLOAD = DTS_REQUEST_URL + "/upload";

// Bags and Tripsheet
export const BAG = "bags";
export const BAG_SUGGESTION = BAG + "/search";
export const TRIP_SHEET = "trip-sheets";

// Manifest (custom shipment upload)
export const MANIFEST = "/manifest";
export const MANIFEST_ORDER = "/manifest-order";
export const MANIFEST_FILE_UPLOAD = `${MANIFEST}/file-upload`;
export const MANIFEST_UPDATE_ORDER_STATUS = `${MANIFEST}/orders/update-status`;

// Cargo URL
export const CARGO = "/cargo";
export const AIR = "/air";
export const CARGO_UPDATE_REMARK = CARGO + "/update-remark";
export const CARGO_MARK_DELIVERED = CARGO + "/mark-delivered";

// Cargo Manifest (custom shipment upload)
export const CARGO_MANIFEST = "/cargo-manifests";
export const CARGO_MANIFEST_ORDER = `${CARGO_MANIFEST}/orders`;
export const CARGO_MANIFEST_FILE_UPLOAD = `${CARGO_MANIFEST}/file-upload`;
export const CARGO_START_CLEARANCE = `${CARGO_MANIFEST}/orders/start-clearance`;
export const CARGO_CLEARANCE_COMPLETED = `${CARGO_MANIFEST}/orders/clearance-completed`;
export const CARGO_HELD_AT = `${CARGO_MANIFEST}/orders/clearance-held-at`;
export const CARGO_IN_SCAN = `${CARGO}/in-scan`;
export const CARGO_OUT_SCAN = `${CARGO}/out-scan`;
export const CARGO_DEST_IN_SCAN = `${CARGO}/dest-in-scan`;

// TPL Manifest (shipment upload)
export const TPL_MANIFEST = "/tpl-manifest";
export const TPL_MANIFEST_ORDER = "/tpl-manifest-order";
export const TPL_MANIFEST_FILE_UPLOAD = `${TPL_MANIFEST}/file-upload`;
export const PRINT_TPL_MANIFEST = `${BASE_URL}/print-tpl-manifest`;
export const TPL_MANIFEST_DRAFT = `${TPL_MANIFEST}/draft`;
export const TPL_MANIFEST_CHECK_ORDER = `${TPL_MANIFEST}/check-order`;

// B2B URL
export const B2B = "/b2b";
export const B2B_UPDATE_REMARK = B2B + "/update-remark";
export const B2B_MARK_DELIVERED = B2B + "/mark-delivered";

// Handed over to TPL scan
export const HANDED_OVER_TO_TPL_SCAN = THREEPL_URL + "/handed-over-to-tpl-scan";

// LastMile: Delivery Run Sheet
export const DELIVERY_RUN_SHEET = "delivery-run-sheet";
export const DELIVERY_RUN_SHEET_SEARCH_ORDERS =
  "delivery-run-sheet/search-orders";
export const DELIVERY_RUN_SHEET_PRINT_URL = "/print-run-sheet";
export const RVP_RUN_SHEET = "rvp-run-sheet";
export const RVP_RUN_SHEET_ORDERS = "rvp-run-sheet/orders";
export const RVP_RUN_SHEET_PRINT_URL = "/print-rvp-run-sheet";
export const EXPORT_RUN_SHEET = "delivery-run-sheet/export";
export const EXPORT_DISPATCH_RUN_SHEET = "delivery-run-sheet/export-disptach";
export const DELIVERY_RUN_SHEET_ORDERS = DELIVERY_RUN_SHEET + "/orders";
export const DELIVERY_RUN_SHEET_FILTER_URL = DELIVERY_RUN_SHEET + "/filter";

export const CUSTOMS = "customs";
export const FIRST_MILE = "first-mile";
export const IN_BOUND = "in-bound";
export const OUT_BOUND = "out-bound";
export const LAST_MILE = "last-mile";
export const RETURN = "return";
export const RVP = "rvp";

// Client operations
export const ORDERS_PRINT_LABEL_URL = "orders/print-label";
export const CLIENT_ORDERS_EXPORT_URL = "orders/excel-export";
export const CLIENT_SUPPORT_TICKETS_URL = "clients/support-tickets";
export const CLIENT_EXCEL_EXPORT_LOGS_URL = "/clients/logs/excel-export";
export const CLIENT_PRINT_LABEL_LOGS_URL = "/clients/logs/print-label";

// Order listing
export const CUSTOMS_ORDER_LIST = CUSTOMS + "/orders";
export const FIRST_MILE_ORDER_LIST = FIRST_MILE + "/orders";
export const LASR_MILE_ORDER_LIST = LAST_MILE + "/orders";
export const IN_BOUND_ORDER_LIST = IN_BOUND + "/orders";
export const OUT_BOUND_ORDER_LIST = OUT_BOUND + "/orders";

// Shipment summary
export const SHIPMENT_SUMMARY_URL = "shipment-summary";
export const SHIPMENT_SUMMARY_ORDERS_URL = "shipment-summary/orders";

// Customs operations
export const SCAN_HELD_AT_CUSTOM = CUSTOMS + "/heldatcustoms";
export const SCAN_CUSTOMS_CLEARED = CUSTOMS + "/customscleared";

// Shipment Count
export const SHIPMENT_COUNT_URL = "/admin/scan-summary";
export const DAILY_DELIVERY_REPORT = "delivery-report";

// Current product stock WMS
export const CLIENT_CURRENT_PRODUCT_STOCK = "/wms/inventory";
export const CLIENT_CURRENT_PRODUCT_STOCK_V2 = CLIENTS + "/wms/v2/products";
export const CLIENT_STOCK_INFO = CLIENTS + "/wms/stock-info";
export const CLIENT_CURRENT_PRODUCT_STOCK_EXPORT =
  CLIENTS + "/wms/products/export";

// handed over to courier
export const HANDED_OVER_TO_COURIER_URL = "/handed-over-to-courier";

// Payment
export const PAYMENT_TRANSACTIONS = "/payment-transactions";
export const GENERATE_MERCHALINK_PAYMENT_URL = "/payment-transactions/url/merchalink";
